module.exports = __webpack_public_path__ + "static/media/296351.c450cf18.png";